import React, { useRef, useEffect, useState } from "react";
import CollapseCommand from "../Commands/CollapseCommand/CollapseCommand";
import SortCommand from "../Commands/SortCommand/SortCommand";
import ReduceCommand from "../Commands/ReduceCommand/ReduceCommand";
import SearchIcon from "../Commands/SearchIcon/SearchIcon";
import CheckBox from "../Commands/CheckBox/CheckBox";
import NextIcon from "../Commands/NextIcon/NextIcon";
import PreviousIcon from "../Commands/PreviousIcon/PreviousIcon";
import useGetPositionById from "../../Hooks/useGetPositionById";
import ToolTip from "../ToolTip/ToolTip";
import ReactDOM from "react-dom";
import "./DropDownList.css";

export default function DropDownListNew(props) {
  const [isShowToolTip, setIsShowToolTip] = useState(false);
  /*const [isExpanded, setIsExpanded] = useState(false);*/
  const [dropDown, setDropDown] = useState({currentValue: props.initialValue, isExpanded:false, left:0, top:0, selectedValues:props.selectedValues});
  //const [selectedValues, setSelectedValues] = useState(props.selectedValues);
  const getPositionById = useGetPositionById();
 
  function useOutsideAlerter(ref) {
    
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        
        if (ref.current && !ref.current.contains(event.target)) {
          
          if (dropDown.isExpanded &&
          event.target.parentNode.className != "itemContainer" &&
          event.target.className != "itemContainer" &&
          event.target.parentNode.parentNode &&
          event.target.parentNode.parentNode.className != "itemContainer" ) {
            var updatedDropDown = JSON.parse(JSON.stringify(dropDown));
            updatedDropDown.isExpanded = false
            
            setDropDown(updatedDropDown);
          }

          /*
            dropDown.isExpanded &&
            event.target.parentNode.className != "itemContainer" &&
            event.target.className != "itemContainer" &&
            event.target.parentNode.parentNode &&
            event.target.parentNode.parentNode.className != "itemContainer" &&
            setDropDown({currentValue: dropDown.currentValue, isExpanded:false, left:dropDown.left, top:dropDown.top});
            */
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [dropDown.isExpanded]);
  }

  useEffect(() => {
    if(props.initialValue!==dropDown.currentValue) {
      var updatedDropDown = JSON.parse(JSON.stringify(dropDown));
      updatedDropDown.currentValue = props.initialValue
      
      setDropDown(updatedDropDown);
      //setDropDown({currentValue: props.initialValue, isExpanded: dropDown.isExpanded, left:dropDown.left, top:dropDown.top} );
    }
      
  }, [props.initialValue]);

  useEffect(() => {
    
    var updatedDropDown = JSON.parse(JSON.stringify(dropDown));
    updatedDropDown.isExpanded = props.isExternalExpanded
    setDropDown(updatedDropDown);
    
  }, [props.isExternalExpanded]);

  const handleClickItem = (e, item) => {
    var updatedDropDown = JSON.parse(JSON.stringify(dropDown));
    e.stopPropagation();
      if ((!props.multiSelection || props.multiSelection == false) && (!props.isExternalExpanded || props.isExternalExpanded == false)
      ) {
        /*setCurrentValue(item.item);
        setIsExpanded(false);*/
        updatedDropDown.currentValue = item.item;
        updatedDropDown.isExpanded = false;
        //setDropDown( {currentValue: item.item, isExpanded:false, left:dropDown.left, top:dropDown.top} );
        setDropDown(updatedDropDown );
      } 
     
      
    props.onDropDownItemClick(item);
    
  };

  const onClickPrevious = (e, item) => {
    e.stopPropagation();
    props.onClickPrevious(item);
  };
  const onClickNext = (e, item) => {
    e.stopPropagation();
    props.onClickNext(item);
  };
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  
  const onClickCommand =(e) => {
   // var element = document.getElementById(props.id).getBoundingClientRect();
   // var x = parseInt(e.target.scrollLeft) + element.x + window.scrollX;
   // var y = parseInt(e.target.scrollTop) + element.y -3 + window.scrollY;
    const clickPosition = getPositionById(e, props.id)
    var updatedDropDown = JSON.parse(JSON.stringify(dropDown));
    updatedDropDown.isExpanded = !dropDown.isExpanded
    updatedDropDown.left = clickPosition[0] //x
    updatedDropDown.top = clickPosition[1] //y
    
    setDropDown(updatedDropDown)
    //setDropDown({currentValue: dropDown.currentValue, isExpanded:!dropDown.isExpanded, left:x, top:y} )
  }

  const swicthDropDown =() => {
    var updatedDropDown = JSON.parse(JSON.stringify(dropDown));
    updatedDropDown.isExpanded = !dropDown.isExpanded;
    
    setDropDown(updatedDropDown)
    //setDropDown({currentValue: dropDown.currentValue, isExpanded:!dropDown.isExpanded}
  }

  const getTitle = (item) => {
    return  ( //&& dropDown.isExpanded
      <div className="itemContainer">
        <div style={{width:"20px"}} onClick={(e) => onClickPrevious(e, item.parent)}>
          <PreviousIcon />
        </div>
        <li onClick={(e) => e.stopPropagation()} 
          style={{fontSize: props.fontSize ? props.fontSize : 14,
          fontWeight: props.fontWeight ? props.fontWeight : "normal",
          fontFamily: props.fontFamily ? props.fontFamily :"arial, sans-serif",
          color: props.color ? props.color :"#212121"}} 
          className="liautocomplete" key={"item.id"}>
          {item.parent.item}
        </li>
      </div>)
  }
 
  const getIcon = () => {
    return <div className="commandRow" ref={wrapperRef}>
            <div className="commandLeftCol">
              <span  className="dropDownList"
                style={{
                fontSize: props.fontSize ? props.fontSize : 14,
                fontWeight: props.fontWeight ? props.fontWeight : "normal",
                fontFamily: props.fontFamily ? props.fontFamily :"arial, sans-serif",
                color: props.color ? props.color :"#212121"}}
                //onMouseOver={() => setIsShowToolTip(true)}
                onMouseEnter={() => setIsShowToolTip(true)}
                onMouseLeave={() => setIsShowToolTip(false)}>
                { props.initialValue}
              </span>
            </div>
            { (!props.isContextMenu || props.isContextMenu == false) && (props.onlyLabel ? (
            <div className="commandRightCol" onClick={() => swicthDropDown() }>
              { <SortCommand />}
            </div>
            ) : props.searchIcon ? (
            <div className="commandNextCol" onClick={(e) => onClickCommand(e)}>
              <SearchIcon />
            </div>
            ) : (
            <div className="commandNextCol" onClick={(e) => onClickCommand(e)}>
              <CollapseCommand isShow={!dropDown.isExpanded} isStandard={true} />
              <ReduceCommand isShow={dropDown.isExpanded} isStandard={true} />
            </div>
            ))}
        </div>
  }
  return (
    <div >
      {!props.hideIcon && getIcon() }
      <div
        id={props.id}
        style={{
          zIndex: "9999",
          position: "relative",
        }}/>
      {dropDown.isExpanded
        ? ReactDOM.createPortal(
            <div
              className="resultatRow" style={{left:props.position? props.position.left :dropDown.left
                , top:props.position? props.position.top  :dropDown.top,
                minWidth: props.minWidth ? props.minWidth : "100px"
                , zIndex:2000}}>
              <ul className="ulautocomplete">
                {props.currentData.map((item, index) => 
                (             
                  <React.Fragment key={item.id} >
                    {index == 0 && item.isPreviousActif && getTitle(item)}
                    <div  className="itemContainer" onClick={(e) => !item.isNextActif && handleClickItem(e, item)}>
                    
                      {props.multiSelection == true  && ( //&& dropDown.isExpanded
                        <CheckBox
                          checked={props.selectedValues.includes(item.id)}
                          isLeastOneAndNotAllChildsChecked={false}/>
                      )}
                      <li style={{fontSize: props.fontSize ? props.fontSize : 14,
                        fontWeight: props.fontWeight ? props.fontWeight : "normal",
                        fontFamily: props.fontFamily ? props.fontFamily :"arial, sans-serif",
                        color: props.defaultListColor || !props.color ? "#212121" : props.color }}  
                        className="liautocomplete" key={item.id}>
                        {item.item}
                      </li>
                      {item.isNextActif && ( //&& dropDown.isExpanded
                        <div style={{width :"20px", marginLeft: "auto"}} onClick={(e) => onClickNext(e, item)}>
                          <NextIcon />
                        </div>
                      )}
                  </div>
                  </React.Fragment>
                ))}
              </ul>
            </div>,
            document.body
          )
        : null}
      
    </div>
  );
}
